export const formatFileSize = (sizeInBytes: number | string): string => {
  sizeInBytes = Number(sizeInBytes);

  if (sizeInBytes < 1024) {
    return sizeInBytes + ' B';
  }

  const unitPos = Math.floor(Math.log(sizeInBytes) / Math.log(1024));
  const calculatedSize = sizeInBytes / Math.pow(1024, unitPos);
  const roundedSize = (Math.floor(calculatedSize * 100) / 100).toFixed(2);

  return `${roundedSize} ${'KMGTPEZY'[unitPos - 1]}B`;
};
